import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Control, Controller } from "react-hook-form";
import { generateWeekOptions } from "./utils";
import { ScheduleActionFormData } from "./types";

type CopyToAnotherWeekProps = {
    control: Control<ScheduleActionFormData>;
    currentDate: Date;
    onWeekChange?: (weeks: Array<string>) => void;
};

export const CopyToAnotherWeek = ({ control, currentDate, onWeekChange }: CopyToAnotherWeekProps) => {
    const weekOptions = generateWeekOptions(currentDate);

    return (
        <Controller
            name="selectedWeek"
            control={control}
            render={({ field }) => (
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel id="week-selector-label">Copiar para semanas</InputLabel>
                    <Select
                        labelId="week-selector-label"
                        multiple
                        value={field.value}
                        label="Copiar para semanas"
                        onChange={(e) => {
                            const value = e.target.value as Array<string>;
                            field.onChange(value);
                            onWeekChange?.(value);
                        }}
                        renderValue={(selected) => {
                            if (selected.length === 0) return "";
                            if (selected.length === 1) {
                                const week = weekOptions.find((w) => w.value === selected[0]);
                                return week ? week.label : "";
                            }
                            return `${selected.length} semanas selecionadas`;
                        }}
                    >
                        {weekOptions.map((week) => (
                            <MenuItem
                                key={week.value}
                                value={week.value}
                                disabled={week.isCurrentWeek}
                                sx={
                                    week.isCurrentWeek
                                        ? {
                                              "&.Mui-disabled": { opacity: 1 },
                                              fontWeight: 700,
                                              color: "primary.main",
                                              borderLeft: "3px solid",
                                              borderColor: "primary.main",
                                              backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                                          }
                                        : undefined
                                }
                            >
                                {week.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        />
    );
};
